import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeleteVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeleteVO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly value: RoomBrandBgDelete) {
    JsonSchemaValidator.assert(RoomBrandBgDeleteVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgDelete {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
